import React from 'react';
import PropTypes from 'prop-types';
import Fence from '@xingternal/malt-fence';

import Ad from './Ad';

const FencedAd = props => {
  const { nofence, fenceProps, ...adProps } = props;
  return (
    nofence ? <Ad {...adProps} /> : <Fence max="basic" {...fenceProps}><Ad {...adProps} /></Fence>
  );
};

FencedAd.displayName = 'FencedAd';
FencedAd.propTypes = {
  testId: PropTypes.string,
  bannerType: PropTypes.string,
  fenceProps: PropTypes.object,
};

export default FencedAd;
